export const REQUEST_URL = {
  // auth
  LOGIN: "/user/login",
  VERIFY_TOKEN: "/user/check-token",
  LOAD_ME: "/user/me",

  // product
  FILTER_PRODUCT: "/product/admin/filter-product",
  PRODUCT: "/product",
  PRODUCT_DETAIL: "/product/{PRODUCT_ID}",
  PRODUCT_CATEGORY: "/category",
  PRODUCT_CATEGORY_DETAIL: "/category/{CATEGORY_ID}",
  CREATE_MANY_PRODUCTS: "/product/create-many-product",
  GET_ALL_CATEGORIES: "/category/admin/get-all/categories",

  // career
  CAREER: "/career",
  CAREER_DETAIL: "/career/{CODE}",

  // variant
  CREATE_PRODUCT_VARIANT: "/product/create-product-variant",
  UPDATE_PRODUCT_VARIANT: "/product/update-product-variant/{VARIANT_ID}",
  DELETE_PRODUCT_VARIANT: "/product/delete-product-variant/{VARIANT_ID}",

  // customer
  FILTER_CUSTOMER: "/customer/filter/get-all-customer",
  CREATE_CUSTOMER: "/customer/create-customer",
  CUSTOMER_DETAIL: "/customer/{CUSTOMER_ID}",
  GET_ALL_SHIPPING_ADDRESS: "/shipping/admin/{CUSTOMER_ID}/get-all-shipping",
  CREATE_SHIPPING_ADDRESS: "/shipping/admin/create-shipping",
  UPDATE_SHIPPING_ADDRESS: "/shipping/admin/update-shipping/{ID}",
  ACTIVE_CUSTOMER: "/customer/active-customer",
  INACTIVE_CUSTOMER: "/customer/inactive-customer",

  // blog
  FILTER_BLOG: "/blog",
  BLOG: "/blog",
  BLOG_DETAIL: "/blog/{CODE}",
  FILTER_BLOG_CATEGORY: "/category",
  BLOG_CATEGORY: "/category",
  BLOG_CATEGORY_DETAIL: "/category/{CODE}",
  GET_ALL_AUTHORS: "/author",
  LABEL: "/label",

  // order
  FILTER_ORDER: "/orders/order-filter",
  ORDER_DETAIL: "/orders/{ORDER_ID}",
  ORDER_CONFIRM_PAYMENT: "/orders/payment-confirm-order",
  EXPORT: "/orders/export/excel",

  IMAGE: {
    UPLOAD_PRODUCT: "/product/upload-image-product",
    UPLOAD_PRODUCT_DESCRIPTION: "/description/upload-image",
    UPLOAD_CATEGORY: "/categories/upload-image-category",
    UPLOAD_BLOG: "/blog/upload-image-resource",
    UPLOAD: "/uploadImages",

    UPLOAD_SOLUTION: "/solution/upload-image-solution",
    UPLOAD_FOCUSED_MARKET: "/focused-market/upload-image",
    UPLOAD_BANNER: "/banner/upload-image-resource",
    
    UPLOAD_CAREER: "/career/upload-image-career",
    UPLOAD_COUNTRY: "/network/upload-image-network"
  },

  VIDEO: {
    UPLOAD: "/video/upload-video-file"
  },

  // Agent
  FILTER_AGENT: "/agent",
  CREATE_AGENT: "/agent",
  UPDATE_AGENT: "/agent/{AGENT_ID}",
  DELETE_AGENT: "/agent/{AGENT_ID}",

  // Documentation
  GET_FILE_BY_CATEGORY: "/document",
  UPLOAD_FILE: "/document",
  DELETE_FILE: "/document/{FILE_ID}",
  UPDATE_FILE_STATUS: "/document/{FILE_ID}",

  // Solution Page
  GET_ALL_SOLUTION_PAGE_BY_LANGUAGE: "/solution",
  GET_SOLUTION_PAGE: "/solution/{CODE}",
  CREATE_SOLUTION_PAGE: "/solution",
  UPDATE_SOLUTION_PAGE: "/solution/{CODE}",
  DELETE_SOLUTION_PAGE: "/solution/{CODE}",

   // Focused Market Page
  GET_ALL_FOCUSED_MARKET_PAGE_BY_LANGUAGE: "/focused-market",
  GET_FOCUSED_MARKET_PAGE: "/focused-market/{CODE}",
  CREATE_FOCUSED_MARKET_PAGE: "/focused-market",
  UPDATE_FOCUSED_MARKET_PAGE: "/focused-market/{CODE}",
  DELETE_FOCUSED_MARKET_PAGE: "/focused-market/{CODE}",

  // Language
  GET_ALL_LANGUAGE: "/language",
  CREATE_LANGUAGE: "/language",

  // Banners
  GET_ALL_BANNER_BY_LANGUAGE: "/banner",
  GET_BANNER: "/banner/{CODE}",
  CREATE_BANNER: "/banner",
  UPDATE_BANNER: "/banner/{CODE}",
  UPDATE_BANNER_INDEX: "/banner/available/update",
  DELETE_BANNER: "/banner/{CODE}",

  // Videos
  GET_FILTER_ALL_VIDEO: "/video",
  GET_VIDEO: "/video/{CODE}",
  CREATE_VIDEO: "/video/upload-video",
  UPDATE_VIDEO: "/video/{CODE}",
  DELETE_VIDEO: "/video/{CODE}",

  // Category
  UPDATE_CATEGORY: "/category/{CODE}",
  DELETE_CATEGORY: "category/{CODE}",

  // Network
  GET_ALL_BRANCH_BY_COUNTRY: "/network/branch",
  CREATE_BRANCH: "/network/branch",
  GET_BRANCH_DETAIL: "/network/branch/{BRANCH_ID}",
  UPDATE_BRANCH: "/network/branch/{BRANCH_ID}",
  DELETE_BRANCH: "/network/branch/{BRANCH_ID}",
  GET_ALL_COUNTRY: "/network/country",
  CREATE_COUNTRY: "/network/country",
  DELETE_COUNTRY: "/network/country/{COUNTRY_ID}",

  // Quotation
  FILTER_QUOTATION: "/quotation",
  GET_QUOTATION_DETAIL: "/quotation/{QUOTATION_CODE}",
  GET_QUOTATION_HISTORY: "/quotation/quotation-history/{QUOTATION_ID}",
  CREATE_FREIGHT_FORWARDING: "/quotation/freight_forwarding",
  CREATE_ECOMMERCE_FULFILLMENT: "/quotation/ecommerce_fulfillment",
  UPDATE_QUOTATION: "/quotation/{QUOTATION_CODE}",
  DELETE_QUOTATION: "/quotation/{QUOTATION_CODE}"
};
